import { PageType } from '@app/models/page';

export class PageQuery {

  public PageType: PageType = PageType.News;

  public Featured?: boolean;

  public Channels?: Array<string>;

  public ChannelMatchingMode?: ChannelMatchingMode = ChannelMatchingMode.Or;

  public FindText?: string = null;

  public OwnerOrEditorUpnId?: string = null;

  public IncludeDrafts = false;

  public IncludeArchive = false;

  public StartDate?: Date = null;

  public EndDate?: Date = null;

  public Skip?: number = null;

  public Take?: number = null;

  public hubSiteId?: string;

  constructor(opt?: Partial<PageQuery>) {
    Object.assign(this, opt);
  }

}

export enum ChannelMatchingMode {
  Or = 0,
  And = 1
}
